import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  limit,
} from '@angular/fire/firestore';
import { BehaviorSubject, Subject } from 'rxjs';

export interface AppNotification {
  id: string;
  title: string;
  message: string;
  createdAt: any;
  read: boolean;
  type: string;
  quotationId?: string;
  pricingPerson?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  private notificationsSubject = new BehaviorSubject<AppNotification[]>([]);
  notifications$ = this.notificationsSubject.asObservable();

  private newNotificationSubject = new Subject<AppNotification>();
  newNotification$ = this.newNotificationSubject.asObservable();

  private hasInitialLoad = false;
  private unsubscribe?: () => void;

  constructor(private firestore: Firestore) {}

listenForNotifications(userId: string, role: string) {
  this.unsubscribe?.();
  this.unsubscribe = undefined;
  this.hasInitialLoad = false;

  const notifRef = collection(this.firestore, 'notifications');
  const all: Record<string, AppNotification> = {};

  // 📌 Only pricing dept listens to pricing notifications
  if (role === 'pricing') {
    const qPricing = query(
      notifRef,
      where("pricingPerson", "==", userId),
      orderBy("createdAt", "desc"),
      limit(50)
    );

    this.unsubscribe = onSnapshot(qPricing, (snap) => {
      snap.forEach((docSnap) => {
        all[docSnap.id] = { id: docSnap.id, ...(docSnap.data() as any) };
      });
      this.processNotifications(Object.values(all));
    });
  }else if(role =="sales"){
    const qSales = query(
      notifRef,
      where("salesPerson", "==", userId),
      orderBy("createdAt", "desc"),
      limit(50)
    );

    this.unsubscribe = onSnapshot(qSales, (snap) => {
      snap.forEach((docSnap) => {
        all[docSnap.id] = { id: docSnap.id, ...(docSnap.data() as any) };
      });
      this.processNotifications(Object.values(all));
    });

  }// 🔴 EXPORT-DEPART (MANAGER ONLY → exportInfo)
  else if (role === 'export-depart' || role === 'export depart') {

    const qExport = query(
      notifRef,
      where('type', '==', 'exportInfo'),
      limit(50)
    );

    this.unsubscribe = onSnapshot(qExport, (snap) => {
      snap.forEach((docSnap) => {
        all[docSnap.id] = {
          id: docSnap.id,
          ...(docSnap.data() as any),
        };
      });
      this.processNotifications(Object.values(all));
    });

  }

  // 📌 Sales manager
}

stopListening() {
  this.unsubscribe?.();
  this.unsubscribe = undefined;
  this.notificationsSubject.next([]);
  this.hasInitialLoad = false;
}


  private processNotifications(list: AppNotification[]) {
    const sorted = list.sort((a, b) => {
      return (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0);
    });

    if (this.hasInitialLoad) {
      const oldIds = new Set(this.notificationsSubject.value.map((n) => n.id));
      const newOnes = sorted.filter((n) => !oldIds.has(n.id));
      newOnes.forEach((n) => this.newNotificationSubject.next(n));
    } else {
      this.hasInitialLoad = true;
    }

    this.notificationsSubject.next(sorted);
  }
}
